import { Span } from "@vp/swan";
import React from "react";
import { IPrice } from "../../types/pricing";
import ComparativePrice from "./ComparativePrice";
import VatMessage from "./VatMessage";

interface RawPriceProps {
  pricingInfo: IPrice;
  /** @deprecated ignored; synchronous rendering */
  placeHolderText?: string;
  /** @deprecated use className instead */
  classNameWrapper?: string;
  className?: string;
  /** @deprecated not used */
  tenant?: string;
}

const RawPrice: React.FC<RawPriceProps> = ({
  pricingInfo,
  classNameWrapper,
  className,
}) => {
  const wrapperClass = classNameWrapper || className;
  return (
    <Span className={["swan-pricing", wrapperClass].filter(Boolean).join(" ")}>
      <ComparativePrice
        listPrice={pricingInfo.listPrice}
        discountPrice={pricingInfo.discountPrice}
        currency={pricingInfo.currency}
        locale={pricingInfo.culture}
        minimumFractionDigits={pricingInfo.minimumFractionDigits}
      />
      {!pricingInfo.hideVatMessage && (
        <>
          {" "}
          <VatMessage
            locale={pricingInfo.culture}
            vatInc={pricingInfo.vatInc}
            hideShippingMessageInVatMessage={pricingInfo.hideShippingMessageInVatMessage}
          />
        </>
      )}
    </Span>
  );
};

export default RawPrice;
